import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';


const initialState = {
    soloId: '',
    isMultiRouterEnabled: false,
    loading: false,
    success: false,
    error: false,
    isLoaded: false,
    
};
const resetMultiAdvancedWifiState = (state, action) => {
    return updateObject(state, initialState)
  }
const setSoloId = (state, action) => {
    // console.log(action, 'action ent');
    return updateObject(state, {
        soloId: action.payload && action.payload.soloId
    });
};

const Reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_ENTITLEMENT_SUCCESS: return setSoloId(state, action);
        case actionTypes.GET_ENTITLEMENT_FAILED: return updateObject(state, { soloId: '' });
        case actionTypes.GET_MULTIROUTER_BY_SOLOID_SUCCESS: return updateObject(state, { isMultiRouterEnabled: true, isLoaded: true });
        case actionTypes.GET_MULTIROUTER_BY_SOLOID_FAILED: return updateObject(state, { isMultiRouterEnabled : false, isLoaded: true });
        case actionTypes.CREATE_MULTIADVANCEDWIFI_SUCCESS: return updateObject(state, { success: true, error: false });
        case actionTypes.CREATE_MULTIADVANCEDWIFI_FAILED: return updateObject(state, { success: false, error: true });
        case actionTypes.DELETE_MULTIADVANCEDWIFI_SUCCESS: return updateObject(state, { success: true, error: false });
        case actionTypes.DELETE_MULTIADVANCEDWIFI_FAILED: return updateObject(state, { success: false, error: true });
        case actionTypes.RESET_MULTIADVANCEDWIFI_ERROR_SUCCESS: return updateObject(state, { success: false, error: false });
        default: return state;
    }
};

export default Reducer;
